'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { IntlBlock } from '@sola/ark-core/atoms/intl/Intl.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { trackClick } from '@sola/tracking/components/datalayer.tsx';
import { useDonate } from '../donate-context.tsx';
import { DonateErrorObject, DonateVariants } from '../donate.types.ts';
import { useDonateValidation } from '../hooks/use-donate-validation.tsx';
const DonateErrorAlert: React.FC<{
  message: string | DonateErrorObject;
}> = t0 => {
  const $ = _c(12);
  const {
    message
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  if (typeof message === "string") {
    let t2;
    if ($[1] !== message) {
      t2 = <Alert key="validation-error" variant="negative" message={message} />;
      $[1] = message;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== message.title || $[4] !== t) {
    t2 = message.title && t(message.title.key, message.title.payload);
    $[3] = message.title;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const titleNode = t2;
  let t3;
  if ($[6] !== message.message || $[7] !== t) {
    t3 = message.message && <IntlBlock i18nKey={message.message.key} values={{
      ...message.message.payload
    }} components={{
      anchor: <Link className="link" href={`mailto:${t("contact.emailGiftPlanning")}`}>{t("contact.emailGiftPlanning")}</Link>
    }} />;
    $[6] = message.message;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const bodyNode = t3;
  let t4;
  if ($[9] !== bodyNode || $[10] !== titleNode) {
    t4 = <Alert key="validation-error" variant="negative" title={titleNode} message={bodyNode} />;
    $[9] = bodyNode;
    $[10] = titleNode;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export const DonateSubmitButton: React.FC<{
  className?: string;
  alt?: boolean;
}> = t0 => {
  const $ = _c(27);
  const {
    className,
    alt
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["donations"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const {
    state,
    variant
  } = useDonate();
  const {
    getCurrentAmount,
    validationState
  } = useDonateValidation();
  let t2;
  if ($[1] !== getCurrentAmount) {
    t2 = getCurrentAmount() || "";
    $[1] = getCurrentAmount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const donateAmount = t2;
  const numericAmount = Number(donateAmount);
  let t3;
  if ($[3] !== alt || $[4] !== numericAmount || $[5] !== state.donateFrequency || $[6] !== state.otherSelected || $[7] !== t || $[8] !== variant) {
    t3 = () => {
      if (state.otherSelected && numericAmount <= 0) {
        return t("donations:enterAnAmount");
      }
      if (alt) {
        return t("donations:donate");
      }
      if (variant === DonateVariants.grid && !state.otherSelected) {
        return t("donations:addToBasket");
      }
      if (Number.isNaN(numericAmount)) {
        return t("skippy.donation.donate");
      }
      return t("donations:donateAmount", {
        context: state.donateFrequency,
        amount: numericAmount
      });
    };
    $[3] = alt;
    $[4] = numericAmount;
    $[5] = state.donateFrequency;
    $[6] = state.otherSelected;
    $[7] = t;
    $[8] = variant;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const getButtonText = t3;
  const t4 = `DonateSubmitButton grid gap-snug-xl ${className || ""}`;
  const t5 = validationState.isDisabled || state.isSubmitting;
  const t6 = state.isSubmitting;
  let t7;
  let t8;
  if ($[10] !== getButtonText) {
    t7 = () => {
      trackClick(getButtonText());
    };
    t8 = getButtonText();
    $[10] = getButtonText;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <button type="submit" onClick={t7}>{t8}</button>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== state.isSubmitting || $[17] !== t5 || $[18] !== t9) {
    t10 = <ButtonStyle variant="primary" size="lg" fullWidth={true} disabled={t5} isBusy={t6}>{t9}</ButtonStyle>;
    $[16] = state.isSubmitting;
    $[17] = t5;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== donateAmount || $[21] !== validationState.message) {
    t11 = validationState.message && donateAmount && <DonateErrorAlert message={validationState.message} />;
    $[20] = donateAmount;
    $[21] = validationState.message;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t4) {
    t12 = <div className={t4}>{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t4;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};